import React from 'react';
import { useParams } from 'react-router';
import { useRecoilValue } from 'recoil';
import IntroduceProcessModal from 'components/learning/quiz/components/parts/IntroduceProcessModal';
import { isPageOpenedState, quizDetailPageHeightState } from 'modules/learning/recoilState';
import styled from 'styled-components';

const IntroduceQuizProcess = () => {
  const { operation, id }: { operation: string; id: string } = useParams();
  //도움말 페이지 오픈 여부
  const isPageOpened = useRecoilValue<boolean>(isPageOpenedState);
  //baseTemplate height 크기에 따라서 변동되는 도움말 커버 height
  const heightSize = useRecoilValue(quizDetailPageHeightState);

  return operation === 'view' && isPageOpened ? (
    <>
      <IntroduceQuizProcessWrapper heightSize={heightSize}></IntroduceQuizProcessWrapper>
      <IntroduceProcessModal />
    </>
  ) : null;
};

export default IntroduceQuizProcess;

type TProcessWrapperProps = {
  heightSize: number;
};
const IntroduceQuizProcessWrapper = styled.div<TProcessWrapperProps>`
  width: 100%;
  height: ${(props) => `${props.heightSize}px`};
  background-color: #747474;
  position: absolute;
  z-index: 70;
  opacity: 0.6;
`;
